export default "__VITE_ASSET__D6Y9hGYV__"